export const PACK_SIZES = [250, 400, 600, 800] as const;
export type PackSize = (typeof PACK_SIZES)[number];

export const PACK_VARIANT_IDS: Record<PackSize, string> = {
  250: "variant-id-250",
  400: "variant-id-400",
  600: "variant-id-600",
  800: "variant-id-800",
};
